<template>
    <div class="form-row">
        <div class="col-12">
            <div class="form-group">
                <label
                    v-if="label"
                    class="col-form-label"
                    :class="getLabelClasses()"
                    :for="id">
                    {{ label }}
                    <span class="req">{{ getRequired() }}</span>
                </label>

                <input
                    type="text"
                    class="form-control"
                    :class="getInputClasses()"
                    :placeholder="label"
                    :id="'form-order-' + id"
                    :aria-disabled="disabled"
                    v-model="vm"
                >

                <div class="invalid-feedback" v-if="getError()" v-text="getError()"></div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        methods: {
            getLabelClasses() {
                let classNames = '';
                if (this.getError()) {
                    classNames += 'is-invalid';
                }
                return classNames;
            },
            getInputClasses() {
                let classNames = '';
                if (this.getError()) {
                    classNames += 'is-invalid';
                }
                return classNames;
            },
            getRequired() {
                if (this.required) {
                    return '*';
                }
                return '';
            },
            getError() {
                if (_.isNil(this.errors) || _.isNil(this.errors[this.realName])) {
                    return '';
                }
                return this.errors[this.realName];
            }
        },
        beforeMount() {
            this.userInfo = this.$store.state.cart.userInfo;
            this.vm = this.userInfo[this.realName];
        },
        computed: {

        },
        data: function() {
            return {
                userInfo: {},
                vm: ''
            };
        },
        props: {
            name: String,
            realName: String,
            id: String,
            label: String,
            errors: Object,
            required: Boolean,
            disabled: Boolean
        }
    }
</script>
